export const versionConfig = {
  version: "1.0.23",
  buildDate: "2026-05-18",
  changelog: `
- Add inventory item production disassembly feature
- Simplify production permissions from 5 granular codes to 2 (view/manage)
- Add Manufactured filter and report column to inventory list
- Fix used and picked quantity case_pack conversion for item-family ingredients in production LOT finalization
  `,
  showNotification: true,
  forceReset: false,
  softReset: true
}

// Backward compatibility exports
export const version = versionConfig.version
export const buildDate = versionConfig.buildDate
